module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/frantmatter02"
    }
  }, [_vm._v("Introduction/ Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/frantmatter03"
    }
  }, [_vm._v("Foreword by Joe Dallesandro")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("Little Joe, Superstar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Undress Rehearsal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Loves of Ondine")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Lonesome Cowboys")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("San Diego Surf")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Flesh")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Trash")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Heat")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Gardener")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Flesh for Frankenstein")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Blood for Dracula")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Donna è bello")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Il Tempo degli assassini")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("L’Ambizioso")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Black Moon")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Fango bollente")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Je t’aime moi non plus")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("La Marge")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("L’Ultima volta")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Un Cuore semplice")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("6000 km di paura")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Suor omicidi")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Merry-Go-Round")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Vacanze per un massacro")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Tapage nocturne")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Parano")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Queen Lear")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Cotton Club")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Critical Condition")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sunset")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Double Revenge")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Private War")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Cry-Baby")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Almost an Angel")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter035",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Guncrazy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter036",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bad Love")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter037",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Wild Orchid II: Blue Movie Blue")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter038",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sugar Hill")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter039",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Theodore Rex")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter040",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("L.A. Without a Map")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter041",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Limey")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter042",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Citizens of Perpetual Indulgence")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter043",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Pacino is Missing")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Documentaries/Shorts/TV/Videos")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53e656ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 69
// module chunks = 0